import { atom } from "jotai";

export const productDataAtom = atom([]);
